import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { commonZH, commonEN, commonJA, staticContentZH, staticContentEN, staticContentJA } from '@redpanda/common-locales';
import { mergeTranslations, createI18nInitConfig, deepMerge } from '@redpanda/utils';

// 本地翻譯檔案
import enTranslation from './locales/en/translation.json';
import zhTranslation from './locales/zh/translation.json';
import jaTranslation from './locales/ja/translation.json';
import enStaticContent from './locales/en/static-content.json';
import zhStaticContent from './locales/zh/static-content.json';
import jaStaticContent from './locales/ja/static-content.json';

// staticContent：共用的服務條款／隱私權／退款政策（@redpanda/common-locales）＋帳戶中心自己的方案、系統介紹（同 CRM）
const resources = {
  en: {
    translation: mergeTranslations(commonEN, enTranslation),
    staticContent: deepMerge(staticContentEN, enStaticContent),
  },
  zh: {
    translation: mergeTranslations(commonZH, zhTranslation),
    staticContent: deepMerge(staticContentZH, zhStaticContent),
  },
  ja: {
    translation: mergeTranslations(commonJA, jaTranslation),
    staticContent: deepMerge(staticContentJA, jaStaticContent),
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(createI18nInitConfig({ resources }));

export default i18n;
